import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Partner, PartnerIdentity, PartnerListFilter} from '../models/partner.model';
import {map} from 'rxjs/operators';
import {getHttpParams} from '../helpers/request.helper';
import {mapSearchListResponse} from '../helpers/search.helper';
import {SearchQueryParams} from '../models/search-query-params.model';

@Injectable()
export class PartnerService {
    baseUrl = '/api/secured/partner';

    constructor(
        private http: HttpClient
    ) {}

    fetchSimpleList(filters: PartnerListFilter) {
        return this.http
            .get<PartnerIdentity[]>(`${this.baseUrl}/simple`, {params: getHttpParams(filters), observe: 'response'})
            .pipe(map(response => response.body));
    }

    fetchList(props: SearchQueryParams) {
        return this.http
            .get<Partner[]>(this.baseUrl, {params: props.getHttpParams(), observe: 'response'})
            .pipe(mapSearchListResponse<Partner>(Partner));
    }

    fetchById(id: number) {
        return this.http.get<Partner>(`${this.baseUrl}/${id}`);
    }

    activate(id: number) {
        return this.http.put(`${this.baseUrl}/${id}/activate`, {});
    }

    add(partner: Partner) {
        return this.http.post(this.baseUrl, {...partner});
    }

    update(partner: Partner) {
        return this.http.put(`${this.baseUrl}/${partner.id}`, {...partner});
    }

    deactivate(id: number) {
        return this.http.put(`${this.baseUrl}/${id}/deactivate`, {});
    }

    deactivateSales(id: number) {
        return this.http.put(`${this.baseUrl}/${id}/sell/deactivate`, {});
    }
}
